import { useState } from "react";
import { faqs } from "@/pages/home/data";

export default function FaqGuide() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="guide" className="scroll-anchor bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 text-sm font-bold text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span>
              吃瓜指南
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              常见问题 FAQ
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于看吃瓜的内容来源、可信度、纠错与订阅方式，常见疑问我们都替你整理好了。没有覆盖到的，欢迎来信编辑部。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200"
            >
              <i className="ri-customer-service-2-line" aria-hidden="true"></i>
              没找到答案？联系我们
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-xl bg-background-50">
              {faqs.map((f, i) => {
                const isOpen = openIndex === i;
                return (
                  <div key={i}>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100/60 md:px-6"
                    >
                      <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{f.q}</h3>
                      <span
                        className={
                          "flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors " +
                          (isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700")
                        }
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="max-w-3xl text-sm leading-7 text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}